import { ReactNode } from 'react';
import { Button as MuiButton, CircularProgress, Stack, SxProps, Theme } from '@mui/material';

type ButtonProps = {
  children: ReactNode;
  onClick: () => void;
  type: 'primary' | 'secondary' | 'accent';
  size?: 'small' | 'normal';
  center?: boolean;
  fullWidth?: boolean;
  sx?: SxProps<Theme>;
  disabled?: boolean;
  isLoading?: boolean;
};

export const Button: React.FC<ButtonProps> = ({
  children,
  onClick,
  type,
  size = 'normal',
  sx,
  center,
  fullWidth = true,
  disabled,
  isLoading,
}) => {
  const accentStyles = {
    backgroundColor: 'var(--color-accent)',
    color: 'var(--color-element)',
    border: '1.5px solid var(--color-accent)',
    '&:hover': {
      opacity: 0.9,
    },
    '&:disabled': {
      backgroundColor: 'var(--color-accent)',
      color: 'var(--color-element)',
      border: '1.5px solid var(--color-accent)',
      opacity: 0.4,
    },
  };

  return (
    <Stack direction="row" justifyContent={center ? 'center' : 'flex-start'}>
      <MuiButton
        variant="contained"
        color={type === 'secondary' ? 'secondary' : 'primary'}
        onClick={onClick}
        className={`button-${size}`}
        disabled={disabled}
        sx={{
          ...(type === 'accent' && accentStyles),
          minWidth: 140,
          padding: size === 'small' ? '12px 16px' : '16px',
          ...(fullWidth && { width: '100%', maxWidth: '500px' }),
          ...sx,
        }}
      >
        {isLoading ? <CircularProgress size={20} color="inherit" /> : children}
      </MuiButton>
    </Stack>
  );
};
